import { createContext } from "react";

const RecetaProductoContext = createContext();

export default RecetaProductoContext;
